export default __webpack_public_path__ + "static/media/eggplant.d31ff712.png";